import {useTranslation} from 'react-i18next';
import {AssistantPanel, DetailList} from '@chekinapp/ui';
import {useVelaTripStore} from '../hooks/useVelaTripStore';

function VelaTripGlance() {
  const {t} = useTranslation();
  const trip = useVelaTripStore(state => state.trip);

  if (!trip) return null;

  return (
    <AssistantPanel.Section label={t('travel_guide.at_a_glance')}>
      <DetailList className="[--detail-list-divider:var(--assistant-divider)]">
        <DetailList.Item label={t('travel_guide.destination')} value={trip.destination} />
        {trip.dateRange && (
          <DetailList.Item label={t('travel_guide.dates')} value={trip.dateRange} />
        )}
        <DetailList.Item label={t('travel_guide.days')} value={String(trip.dayCount)} />
        <DetailList.Item
          label={t('travel_guide.stops_label')}
          value={String(trip.totalStops)}
        />
      </DetailList>
    </AssistantPanel.Section>
  );
}

export {VelaTripGlance};
